/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Avatar, Checkbox, Col, Select } from 'antd'
import { Menu, Dropdown, Space } from 'antd'
import { Row } from 'antd'
import { Table } from 'antd'
import { history } from '../../../Redux/app-store'
import actions from '../../../Redux/Organization/action'
import organzationActions from '../../../Redux/Organization/action'
import { useDispatch } from 'react-redux'
import { SearchOutlined } from '@ant-design/icons'
import moment from 'moment'
import filterSvg from '../../../assets/Images/filter.svg'
import editblackPencil from '../../../assets/Images/editblackPencil.svg'
import deleteBlackIcon from '../../../assets/Images/deleteBlackIcon.svg'
import type { ColumnsType, SorterResult } from 'antd/es/table/interface'
import AlertModal from '../../../helper/AlertModal'
import StatusDropdown from '../../../helper/StatusDropdown'
import OrganazationsDataType from '../types'
import { setPaginationObject } from '../../../helper/utility'
import { getNameSignature } from '../../../helper/utility'
import { debounce } from 'lodash'
import OrganizationalModal from '../../../components/modals/organizationModal'
import { OrganizationResp } from 'types/globalTypes'
import { organizationStore } from 'state/organization/organization'
import { Link } from 'react-router-dom'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'

const OrganizationTable = ({
  activeData,
  setParms,
  parms,
  setSelectedRows,
  someState,
  onChangeSomeState,
  status,
  changeStatus,
  refetchOrg,
}: any) => {
  const dispatch = useDispatch()
  const {
    setOrganizationData,
    setOrganizationCurrentStep,
    setOrganizationModalVisible,
    setIsUpdating,
  } = organizationStore(store => ({
    setOrganizationData: store.setOrganizationData,
    setOrganizationCurrentStep: store.setOrganizationCurrentStep,
    setOrganizationModalVisible: store.setOrganizationModalVisible,
    setIsUpdating: store.setIsUpdating,
  }))
  let initPaginationInfo = {
    total: activeData?.count,
    current: parms?.page,
    sort: 'name',
    showTotal: (total: any, range: any) =>
      `Showing ${range[0]} to ${range[1]} of ${total} records`,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20'],
  }
  const [paginationInfo, setPaginationInfo] = useState(initPaginationInfo)
  const [visible, setVisible] = useState(false)
  const [alertModal, setAlertModal] = useState(false)
  const [userId, setUserId] = useState()

  const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({})
  const [data, setData] = useState(activeData)
  const [sortVariable, setSortvariable] = useState('name')
  const [updatePage, setUpdatePage] = useState(0)
  const [showEdit, setEdit] = useState(false)
  const [hiddenColumns, setHiddenColumns] = useState<any>({
    organizationName: true,
    owner: true,
    referralType: true,
    dateApplied: true,
    status: true,
    action: true,
  })
  const onChangeColumnCheckBox = (e: any) => {
    const updatedHiddenColumns = {
      ...hiddenColumns,
      [e.target.name]: e.target.checked,
    }

    setHiddenColumns(updatedHiddenColumns)
    localStorage.setItem(
      'OrganizationCols',
      JSON.stringify(updatedHiddenColumns),
    )
  }
  useEffect(() => {
    setPaginationInfo({
      ...paginationInfo,
      total: activeData.count,
    })
  }, [activeData.count])
  useEffect(() => {
    const storedHiddenColumns = localStorage.getItem('OrganizationCols')
    if (storedHiddenColumns) {
      setHiddenColumns(JSON.parse(storedHiddenColumns))
    }
  }, [])

  const handleSearchChange = (searchValue: string) => {
    setParms((prevParms: any) => ({
      ...prevParms,
      queryString: searchValue,
    }))
  }
  const debounced = debounce(handleSearchChange, 600)
  const handleEditClick = (data: OrganizationResp) => {
    setOrganizationData(data)
    setOrganizationCurrentStep(0)
    setIsUpdating(true)
    setOrganizationModalVisible(true)
  }

  const alertModalData = {
    heading: 'Are you sure want to delete this',
    name: 'organizations',
    id: userId,
  }

  const { updateRouteParams } = useSyncParamsWithRoute(parms, setParms)

  const OrganizationData = activeData?.records?.map(
    (item: OrganizationResp) => {
      return {
        key: item?.id,
        organizationName: item.name,
        organizationAvatar: item.photo?.post,
        owner: item.owner?.firstName,
        ownerAvatar: item.owner?.photo?.post,
        email: item.email,
        address: item.address,
        phone: item.phone,
        EstablishedDate: item.establishedOn,
        about: item.about,
        ownerid: item.ownerId,
        referralType: 'Person Name',
        dateApplied: moment(item.establishedOn).format('DD/MMM/YYYY'),
        createdAt: moment(item.createdAt).format('MMM DD,YYYY'),
        status: item.status === 'approved' ? 'active' : 'pending',
        action: (
          <Space className="orgn-action-btn">
            <img
              src={editblackPencil}
              alt="edit"
              width={20}
              // onClick={() => {
              //   setEdit(true)
              //   setData(item)
              // }}
              onClick={() => handleEditClick(item)}
              className="cursor_pointer"
            />
            {/* Delete = soft-archive; hide it on the Archived tab (already archived) */}
            {status !== 'archived' && (
              <img
                src={deleteBlackIcon}
                alt="delete"
                onClick={e => {
                  setAlertModal(true)
                  setUserId((item as any).id)
                }}
                className="cursor_pointer"
              />
            )}
          </Space>
        ),
      }
    },
  )

  const columns: ColumnsType<OrganazationsDataType> = [
    {
      title: 'Organization Name',
      dataIndex: 'organizationName',
      key: 'organizationName',

      render: (text, organizations, record: any) => (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            history.push({
              pathname: `/organization/${organizations?.key}`,
              state: organizations?.key,
            })
          }}
        >
          <Space size={8}>
            <Avatar size={24} src={organizations?.organizationAvatar}>
              {getNameSignature(text)}
            </Avatar>
            {text}
          </Space>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.organizationName?.length - b.organizationName?.length,
      sortOrder:
        sortedInfo.columnKey === 'organizationName' ? sortedInfo.order : null,

      className: hiddenColumns.organizationName === false ? 'display-none' : '',
    },

    {
      title: 'Admin Name',
      dataIndex: 'owner',
      key: 'owner',
      render: (text, record: any, index) => (
        <Link to={`/organizer/${record.ownerid}`}>
          <Space size={8}>
            <Avatar size={24} src={record.ownerAvatar}>
              {getNameSignature(record.owner)}
            </Avatar>
            <p className="text-black">{text}</p>
          </Space>
        </Link>
      ),
      sorter: (a: any, b: any) => a.owner?.length - b.owner?.length,
      sortOrder: sortedInfo.columnKey === 'owner' ? sortedInfo.order : null,
      className: hiddenColumns.owner === false ? 'display-none' : '',
    },
    {
      title: 'Date CreatedAt',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a: any, b: any) => a.createdAt?.length - b.createdAt?.length,
      sortOrder: sortedInfo.columnKey === 'createdAt' ? sortedInfo.order : null,
      className: hiddenColumns.createdAt === false ? 'display-none' : '',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      className: hiddenColumns.status === false ? 'display-none' : '',
      render: (_cellStatus, record: any, title) => (
        <StatusDropdown
          id={record?.key}
          name="organization"
          // Use the tab's status (component prop), not the per-row cell value which
          // collapses every non-approved status (incl. archived) to 'pending'.
          status={status}
          changeFn={changeStatus}
          refetchData={refetchOrg}
        />
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      width: 120,
      className: hiddenColumns.action === false ? 'display-none' : '',
    },
  ]

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRows(selectedRows)
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  }

  const menu2 = (
    <Menu
      title="show all"
      items={[
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.organizationName}
                  name="organizationName"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Organization Name</Col>
            </Row>
          ),
          key: 1,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.owner}
                  name="owner"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Admin Name </Col>
            </Row>
          ),
          key: 2,
        },

        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.dateApplied}
                  name="createdAt"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Date Created At</Col>
            </Row>
          ),
          key: 4,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.status}
                  name="status"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>status</Col>
            </Row>
          ),
          key: 5,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.action}
                  name="action"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Action</Col>
            </Row>
          ),
          key: 6,
        },
      ]}
    />
  )

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag)
  }

  const handleChangeSortName = (value: string) => {
    setParms({ ...parms, sort: value })
    setSortvariable(value)
    onChangeSomeState()
  }

  const handleChangeStateClick = () => {
    onChangeSomeState(someState + 1)
  }

  const onTableChange = (...rest: any) => {
    const newObject: any = [...rest]
    let newPaginationInfo = setPaginationObject.apply(paginationInfo, newObject)
    handleChangeStateClick()
    getOrganizations(newPaginationInfo)
    setPaginationInfo({ ...newPaginationInfo, page: newPaginationInfo.current })
  }

  const getOrganizations = (newPaginationInfo: any) => {
    // setParms((prev: any) => ({
    //   ...prev,
    //   page: newPaginationInfo.current,
    //   status: status,
    // }))
    updateRouteParams({
      page: newPaginationInfo.current,
    })
    setUpdatePage(updatePage + 1)
  }

  return (
    <>
      <div>
        <Row className="container">
          <Table
            className="organizations_table organization_pagination"
            rowSelection={rowSelection}
            style={{ width: '100%' }}
            columns={columns}
            dataSource={OrganizationData}
            rowKey="key"
            pagination={paginationInfo}
            scroll={{ x: 400 }}
            onChange={onTableChange}
          />
        </Row>
        {alertModal && (
          <AlertModal
            isModalVisible={alertModal}
            setIsModalVisible={setAlertModal}
            data={alertModalData}
            onYesClick={() => {
              dispatch({
                type: organzationActions.DELETE_ORGANIZATION_REQUEST,
                payload: userId,
              })

              dispatch({
                type: actions.GET_ORGANIZATIONS,
                params: paginationInfo,
                payload: { status: status },
              })
            }}
          />
        )}
        {showEdit && (
          <OrganizationalModal
            visible={showEdit}
            setVisblie={setEdit}
            prevdata={data}
          />
        )}
      </div>
    </>
  )
}

export default OrganizationTable
